import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "report-settings" }
const _hoisted_2 = { class: "row mb-4" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = { class: "panel-title" }
const _hoisted_5 = { class: "text-muted" }
const _hoisted_6 = {
  key: 2,
  class: "card bg-dark text-light"
}
const _hoisted_7 = { class: "card-header" }
const _hoisted_8 = { class: "nav nav-tabs card-header-tabs" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "card-body" }
const _hoisted_11 = {
  key: 0,
  class: "tab-content"
}
const _hoisted_12 = { class: "d-flex justify-content-between align-items-center mb-4" }
const _hoisted_13 = { class: "text-muted mb-0" }
const _hoisted_14 = { class: "btn-group" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = ["disabled"]
const _hoisted_17 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-1"
}
const _hoisted_18 = {
  key: 1,
  class: "fas fa-save me-1"
}
const _hoisted_19 = { class: "row g-4" }
const _hoisted_20 = { class: "col-md-4" }
const _hoisted_21 = { class: "setting-card p-3 rounded" }
const _hoisted_22 = { class: "form-label" }
const _hoisted_23 = ["title"]
const _hoisted_24 = { class: "input-group" }
const _hoisted_25 = { class: "input-group-text bg-dark text-light border-secondary" }
const _hoisted_26 = { class: "text-muted" }
const _hoisted_27 = { class: "col-md-4" }
const _hoisted_28 = { class: "setting-card p-3 rounded" }
const _hoisted_29 = { class: "form-label" }
const _hoisted_30 = ["title"]
const _hoisted_31 = { class: "input-group" }
const _hoisted_32 = { class: "input-group-text bg-dark text-light border-secondary" }
const _hoisted_33 = { class: "text-muted" }
const _hoisted_34 = { class: "col-md-4" }
const _hoisted_35 = { class: "setting-card p-3 rounded" }
const _hoisted_36 = { class: "form-label" }
const _hoisted_37 = ["title"]
const _hoisted_38 = { class: "input-group" }
const _hoisted_39 = { class: "input-group-text bg-dark text-light border-secondary" }
const _hoisted_40 = { class: "text-muted" }
const _hoisted_41 = { class: "setting-card p-3 rounded" }
const _hoisted_42 = { class: "form-label" }
const _hoisted_43 = ["title"]
const _hoisted_44 = { class: "input-group" }
const _hoisted_45 = ["onUpdate:modelValue"]
const _hoisted_46 = { class: "input-group-text bg-dark text-light border-secondary" }
const _hoisted_47 = { class: "text-muted" }
const _hoisted_48 = { class: "col-12" }
const _hoisted_49 = { class: "text-muted" }
const _hoisted_50 = {
  key: 1,
  class: "tab-content"
}
const _hoisted_51 = { class: "d-flex justify-content-between align-items-center mb-4" }
const _hoisted_52 = { class: "text-muted mb-0" }
const _hoisted_53 = { class: "btn-group" }
const _hoisted_54 = ["disabled"]
const _hoisted_55 = ["disabled"]
const _hoisted_56 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-1"
}
const _hoisted_57 = {
  key: 1,
  class: "fas fa-save me-1"
}
const _hoisted_58 = { class: "row g-3" }
const _hoisted_59 = { class: "col-12" }
const _hoisted_60 = { class: "text-primary mb-3" }
const _hoisted_61 = { class: "col-md-3" }
const _hoisted_62 = { class: "setting-card p-3 rounded" }
const _hoisted_63 = { class: "form-label" }
const _hoisted_64 = { class: "input-group" }
const _hoisted_65 = { class: "input-group-text bg-dark text-light border-secondary" }
const _hoisted_66 = { class: "text-muted" }
const _hoisted_67 = { class: "col-md-3" }
const _hoisted_68 = { class: "setting-card p-3 rounded" }
const _hoisted_69 = { class: "form-label" }
const _hoisted_70 = { class: "input-group" }
const _hoisted_71 = { class: "input-group-text bg-dark text-light border-secondary" }
const _hoisted_72 = { class: "text-muted" }
const _hoisted_73 = { class: "col-md-3" }
const _hoisted_74 = { class: "setting-card p-3 rounded" }
const _hoisted_75 = { class: "form-label" }
const _hoisted_76 = { class: "input-group" }
const _hoisted_77 = { class: "input-group-text bg-dark text-light border-secondary" }
const _hoisted_78 = { class: "text-muted" }
const _hoisted_79 = { class: "col-md-3" }
const _hoisted_80 = { class: "setting-card p-3 rounded" }
const _hoisted_81 = { class: "form-label" }
const _hoisted_82 = { class: "input-group" }
const _hoisted_83 = { class: "input-group-text bg-dark text-light border-secondary" }
const _hoisted_84 = { class: "text-muted" }
const _hoisted_85 = { class: "col-12 mt-4" }
const _hoisted_86 = { class: "text-primary mb-3" }
const _hoisted_87 = { class: "col-md-3" }
const _hoisted_88 = { class: "setting-card p-3 rounded" }
const _hoisted_89 = { class: "form-label" }
const _hoisted_90 = { class: "input-group" }
const _hoisted_91 = { class: "input-group-text bg-dark text-light border-secondary" }
const _hoisted_92 = { class: "text-muted" }
const _hoisted_93 = { class: "col-md-3" }
const _hoisted_94 = { class: "setting-card p-3 rounded" }
const _hoisted_95 = { class: "form-label" }
const _hoisted_96 = { class: "input-group" }
const _hoisted_97 = { class: "input-group-text bg-dark text-light border-secondary" }
const _hoisted_98 = { class: "text-muted" }
const _hoisted_99 = { class: "col-md-3" }
const _hoisted_100 = { class: "setting-card p-3 rounded" }
const _hoisted_101 = { class: "form-label" }
const _hoisted_102 = { class: "input-group" }
const _hoisted_103 = { class: "input-group-text bg-dark text-light border-secondary" }
const _hoisted_104 = { class: "text-muted" }
const _hoisted_105 = { class: "col-md-3" }
const _hoisted_106 = { class: "setting-card p-3 rounded" }
const _hoisted_107 = { class: "form-label" }
const _hoisted_108 = { class: "input-group" }
const _hoisted_109 = { class: "input-group-text bg-dark text-light border-secondary" }
const _hoisted_110 = { class: "text-muted" }
const _hoisted_111 = { class: "col-12 mt-4" }
const _hoisted_112 = { class: "text-primary mb-3" }
const _hoisted_113 = { class: "col-md-4" }
const _hoisted_114 = { class: "setting-card p-3 rounded" }
const _hoisted_115 = { class: "form-label" }
const _hoisted_116 = { class: "input-group" }
const _hoisted_117 = { class: "input-group-text bg-dark text-light border-secondary" }
const _hoisted_118 = { class: "text-muted" }
const _hoisted_119 = {
  key: 2,
  class: "tab-content"
}
const _hoisted_120 = { class: "d-flex justify-content-between align-items-center mb-4" }
const _hoisted_121 = { class: "text-muted mb-0" }
const _hoisted_122 = { class: "btn-group" }
const _hoisted_123 = ["disabled"]
const _hoisted_124 = ["disabled"]
const _hoisted_125 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-1"
}
const _hoisted_126 = {
  key: 1,
  class: "fas fa-save me-1"
}
const _hoisted_127 = { class: "row g-4" }
const _hoisted_128 = { class: "col-12" }
const _hoisted_129 = { class: "text-primary mb-3" }
const _hoisted_130 = { class: "col-md-4" }
const _hoisted_131 = { class: "setting-card p-3 rounded" }
const _hoisted_132 = { class: "form-label" }
const _hoisted_133 = { class: "text-muted" }
const _hoisted_134 = { class: "col-md-4" }
const _hoisted_135 = { class: "setting-card p-3 rounded" }
const _hoisted_136 = { class: "form-label" }
const _hoisted_137 = { class: "text-muted" }
const _hoisted_138 = { class: "col-md-4" }
const _hoisted_139 = { class: "setting-card p-3 rounded" }
const _hoisted_140 = { class: "form-label" }
const _hoisted_141 = ["max"]
const _hoisted_142 = { class: "text-muted" }
const _hoisted_143 = { class: "col-md-4" }
const _hoisted_144 = { class: "setting-card p-3 rounded" }
const _hoisted_145 = { class: "form-label" }
const _hoisted_146 = { value: "simple" }
const _hoisted_147 = { value: "super" }
const _hoisted_148 = { class: "text-muted" }
const _hoisted_149 = { class: "col-12 mt-4" }
const _hoisted_150 = { class: "text-primary mb-3" }
const _hoisted_151 = { class: "col-md-3" }
const _hoisted_152 = { class: "setting-card p-3 rounded" }
const _hoisted_153 = { class: "form-label" }
const _hoisted_154 = ["max"]
const _hoisted_155 = { class: "text-muted" }
const _hoisted_156 = {
  key: 0,
  class: "text-warning d-block"
}
const _hoisted_157 = { class: "col-md-3" }
const _hoisted_158 = { class: "setting-card p-3 rounded" }
const _hoisted_159 = { class: "form-label" }
const _hoisted_160 = { class: "text-muted" }
const _hoisted_161 = { class: "col-md-3" }
const _hoisted_162 = { class: "setting-card p-3 rounded" }
const _hoisted_163 = { class: "form-label" }
const _hoisted_164 = { class: "input-group" }
const _hoisted_165 = { class: "input-group-text bg-dark text-light border-secondary" }
const _hoisted_166 = { class: "text-muted" }
const _hoisted_167 = { class: "col-md-3" }
const _hoisted_168 = { class: "setting-card p-3 rounded" }
const _hoisted_169 = { class: "form-label" }
const _hoisted_170 = { class: "text-muted" }
const _hoisted_171 = { class: "col-md-3" }
const _hoisted_172 = { class: "setting-card p-3 rounded" }
const _hoisted_173 = { class: "form-label" }
const _hoisted_174 = { class: "form-check form-switch mt-2" }
const _hoisted_175 = {
  class: "form-check-label",
  for: "excludeStaff"
}
const _hoisted_176 = { class: "text-muted" }
const _hoisted_177 = { class: "col-md-3" }
const _hoisted_178 = { class: "setting-card p-3 rounded" }
const _hoisted_179 = { class: "form-label" }
const _hoisted_180 = { class: "form-check form-switch mt-2" }
const _hoisted_181 = {
  class: "form-check-label",
  for: "excludeSameFaction"
}
const _hoisted_182 = { class: "text-muted" }
const _hoisted_183 = { class: "col-md-3" }
const _hoisted_184 = { class: "setting-card p-3 rounded" }
const _hoisted_185 = { class: "form-label" }
const _hoisted_186 = { class: "form-check form-switch mt-2" }
const _hoisted_187 = {
  class: "form-check-label",
  for: "excludeKnownUsers"
}
const _hoisted_188 = { class: "text-muted" }
const _hoisted_189 = { class: "col-md-3" }
const _hoisted_190 = { class: "setting-card p-3 rounded" }
const _hoisted_191 = { class: "form-label" }
const _hoisted_192 = { class: "input-group" }
const _hoisted_193 = { class: "input-group-text bg-dark text-light border-secondary" }
const _hoisted_194 = { class: "text-muted" }
const _hoisted_195 = { class: "col-md-3" }
const _hoisted_196 = { class: "setting-card p-3 rounded" }
const _hoisted_197 = { class: "form-label" }
const _hoisted_198 = { class: "text-muted" }
const _hoisted_199 = { class: "col-md-3" }
const _hoisted_200 = { class: "setting-card p-3 rounded" }
const _hoisted_201 = { class: "form-label" }
const _hoisted_202 = { class: "text-muted" }
const _hoisted_203 = {
  key: 3,
  class: "tab-content"
}
const _hoisted_204 = { class: "d-flex justify-content-between align-items-center mb-4" }
const _hoisted_205 = { class: "text-muted mb-0" }
const _hoisted_206 = { class: "btn-group" }
const _hoisted_207 = ["disabled"]
const _hoisted_208 = ["disabled"]
const _hoisted_209 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-1"
}
const _hoisted_210 = {
  key: 1,
  class: "fas fa-save me-1"
}
const _hoisted_211 = { class: "row g-4" }
const _hoisted_212 = { class: "col-md-3" }
const _hoisted_213 = { class: "setting-card p-3 rounded" }
const _hoisted_214 = { class: "form-label" }
const _hoisted_215 = { value: "any" }
const _hoisted_216 = { value: "auto_assign" }
const _hoisted_217 = { class: "text-muted" }
const _hoisted_218 = { class: "col-md-3" }
const _hoisted_219 = { class: "setting-card p-3 rounded" }
const _hoisted_220 = { class: "form-label" }
const _hoisted_221 = { class: "text-muted" }
const _hoisted_222 = { class: "col-md-3" }
const _hoisted_223 = { class: "setting-card p-3 rounded" }
const _hoisted_224 = { class: "form-label" }
const _hoisted_225 = { value: "majority_of_cast" }
const _hoisted_226 = { value: "percent_of_pool" }
const _hoisted_227 = { class: "text-muted" }
const _hoisted_228 = {
  key: 0,
  class: "col-md-3"
}
const _hoisted_229 = { class: "setting-card p-3 rounded" }
const _hoisted_230 = { class: "form-label" }
const _hoisted_231 = { class: "text-muted" }
const _hoisted_232 = {
  key: 1,
  class: "col-md-3"
}
const _hoisted_233 = { class: "setting-card p-3 rounded" }
const _hoisted_234 = { class: "form-label" }
const _hoisted_235 = { class: "text-muted" }
const _hoisted_236 = {
  key: 2,
  class: "col-md-3"
}
const _hoisted_237 = { class: "setting-card p-3 rounded" }
const _hoisted_238 = { class: "form-label" }
const _hoisted_239 = { class: "text-muted" }
const _hoisted_240 = {
  key: 4,
  class: "tab-content"
}
const _hoisted_241 = { class: "d-flex justify-content-between align-items-center mb-4" }
const _hoisted_242 = { class: "text-muted mb-0" }
const _hoisted_243 = { class: "btn-group" }
const _hoisted_244 = ["disabled"]
const _hoisted_245 = ["disabled"]
const _hoisted_246 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-1"
}
const _hoisted_247 = {
  key: 1,
  class: "fas fa-save me-1"
}
const _hoisted_248 = { class: "row g-4" }
const _hoisted_249 = { class: "col-md-4" }
const _hoisted_250 = { class: "setting-card p-3 rounded" }
const _hoisted_251 = { class: "form-label" }
const _hoisted_252 = { class: "d-flex align-items-center gap-3" }
const _hoisted_253 = {
  class: "badge bg-primary",
  style: {"min-width":"50px"}
}
const _hoisted_254 = { class: "text-muted" }
const _hoisted_255 = { class: "col-md-4" }
const _hoisted_256 = { class: "setting-card p-3 rounded" }
const _hoisted_257 = { class: "form-label" }
const _hoisted_258 = { value: "severity" }
const _hoisted_259 = { value: "quantity" }
const _hoisted_260 = { value: "both" }
const _hoisted_261 = { class: "text-muted" }
const _hoisted_262 = { class: "col-md-4" }
const _hoisted_263 = { class: "setting-card p-3 rounded" }
const _hoisted_264 = { class: "form-label" }
const _hoisted_265 = { class: "text-muted" }
const _hoisted_266 = {
  key: 5,
  class: "tab-content"
}
const _hoisted_267 = { class: "d-flex justify-content-between align-items-center mb-4" }
const _hoisted_268 = { class: "text-muted mb-0" }
const _hoisted_269 = { class: "btn-group" }
const _hoisted_270 = ["disabled"]
const _hoisted_271 = ["disabled"]
const _hoisted_272 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-1"
}
const _hoisted_273 = {
  key: 1,
  class: "fas fa-save me-1"
}
const _hoisted_274 = { class: "row g-4" }
const _hoisted_275 = { class: "col-md-4" }
const _hoisted_276 = { class: "setting-card p-3 rounded" }
const _hoisted_277 = { class: "form-label" }
const _hoisted_278 = { class: "text-muted" }
const _hoisted_279 = { class: "col-md-4" }
const _hoisted_280 = { class: "setting-card p-3 rounded" }
const _hoisted_281 = { class: "form-label" }
const _hoisted_282 = { class: "text-muted" }
const _hoisted_283 = { class: "col-md-4" }
const _hoisted_284 = { class: "setting-card p-3 rounded" }
const _hoisted_285 = { class: "form-label" }
const _hoisted_286 = { class: "text-muted" }
const _hoisted_287 = { class: "col-md-4" }
const _hoisted_288 = { class: "setting-card p-3 rounded" }
const _hoisted_289 = { class: "form-label" }
const _hoisted_290 = { class: "form-check form-switch mt-2" }
const _hoisted_291 = {
  class: "form-check-label",
  for: "allowAnonymous"
}
const _hoisted_292 = { class: "text-muted" }
const _hoisted_293 = { class: "col-md-4" }
const _hoisted_294 = { class: "setting-card p-3 rounded" }
const _hoisted_295 = { class: "form-label" }
const _hoisted_296 = { class: "form-check form-switch mt-2" }
const _hoisted_297 = {
  class: "form-check-label",
  for: "requireEvidence"
}
const _hoisted_298 = { class: "text-muted" }
const _hoisted_299 = { class: "toast-container position-fixed bottom-0 end-0 p-3" }
const _hoisted_300 = { class: "toast-header bg-dark text-light" }
const _hoisted_301 = { class: "me-auto" }
const _hoisted_302 = { class: "toast-body bg-dark text-light" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PanelNoAccess = _resolveComponent("PanelNoAccess")!
  const _component_StateBlock = _resolveComponent("StateBlock")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.$t('panel.reportSettings.title')), 1),
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('panel.reportSettings.subtitle')), 1)
      ])
    ]),
    (_ctx.forbidden)
      ? (_openBlock(), _createBlock(_component_PanelNoAccess, { key: 0 }))
      : (_ctx.initialLoading)
        ? (_openBlock(), _createBlock(_component_StateBlock, {
            key: 1,
            loading: "",
            padding: "py-5"
          }))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("ul", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: "nav-item",
                    key: tab.id
                  }, [
                    _createElementVNode("button", {
                      class: _normalizeClass(["nav-link", { 'active': _ctx.activeTab === tab.id }]),
                      onClick: ($event: any) => (_ctx.activeTab = tab.id)
                    }, [
                      _createElementVNode("i", {
                        class: _normalizeClass([tab.icon, "me-2"])
                      }, null, 2),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t(tab.label)), 1)
                    ], 10, _hoisted_9)
                  ]))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              (_ctx.activeTab === 'deadlines')
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", null, [
                        _createElementVNode("h5", null, _toDisplayString(_ctx.$t('panel.reportSettings.deadlines.title')), 1),
                        _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t('panel.reportSettings.deadlines.subtitle')), 1)
                      ]),
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("button", {
                          class: "btn btn-outline-secondary btn-sm",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.resetDefaults('deadlines'))),
                          disabled: _ctx.saving
                        }, [
                          _cache[53] || (_cache[53] = _createElementVNode("i", { class: "fas fa-undo me-1" }, null, -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('panel.reportSettings.common.resetDefaults')), 1)
                        ], 8, _hoisted_15),
                        _createElementVNode("button", {
                          class: "btn btn-primary btn-sm",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.saveSettings('deadlines'))),
                          disabled: _ctx.saving
                        }, [
                          (_ctx.saving && _ctx.savingSection === 'deadlines')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_17))
                            : (_openBlock(), _createElementBlock("i", _hoisted_18)),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('panel.reportSettings.common.save')), 1)
                        ], 8, _hoisted_16)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("label", _hoisted_22, [
                            _createTextVNode(_toDisplayString(_ctx.$t('panel.reportSettings.deadlines.response')) + " ", 1),
                            _createElementVNode("i", {
                              class: "fas fa-question-circle text-muted ms-1",
                              "data-bs-toggle": "tooltip",
                              title: _ctx.$t('panel.reportSettings.deadlines.responseHelp')
                            }, null, 8, _hoisted_23)
                          ]),
                          _createElementVNode("div", _hoisted_24, [
                            _withDirectives(_createElementVNode("input", {
                              type: "number",
                              class: "form-control bg-dark text-light",
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.settings.deadlines.responseHours) = $event)),
                              min: "1",
                              max: "720"
                            }, null, 512), [
                              [
                                _vModelText,
                                _ctx.settings.deadlines.responseHours,
                                void 0,
                                { number: true }
                              ]
                            ]),
                            _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.$t('panel.reportSettings.common.hours')), 1)
                          ]),
                          _createElementVNode("small", _hoisted_26, _toDisplayString(_ctx.$t('panel.reportSettings.common.defaultHours', { n: 48 })), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("div", _hoisted_28, [
                          _createElementVNode("label", _hoisted_29, [
                            _createTextVNode(_toDisplayString(_ctx.$t('panel.reportSettings.deadlines.conciliation')) + " ", 1),
                            _createElementVNode("i", {
                              class: "fas fa-question-circle text-muted ms-1",
                              "data-bs-toggle": "tooltip",
                              title: _ctx.$t('panel.reportSettings.deadlines.conciliationHelp')
                            }, null, 8, _hoisted_30)
                          ]),
                          _createElementVNode("div", _hoisted_31, [
                            _withDirectives(_createElementVNode("input", {
                              type: "number",
                              class: "form-control bg-dark text-light",
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.settings.deadlines.conciliationHours) = $event)),
                              min: "1",
                              max: "720"
                            }, null, 512), [
                              [
                                _vModelText,
                                _ctx.settings.deadlines.conciliationHours,
                                void 0,
                                { number: true }
                              ]
                            ]),
                            _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.$t('panel.reportSettings.common.hours')), 1)
                          ]),
                          _createElementVNode("small", _hoisted_33, _toDisplayString(_ctx.$t('panel.reportSettings.common.defaultHours', { n: 72 })), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("div", _hoisted_35, [
                          _createElementVNode("label", _hoisted_36, [
                            _createTextVNode(_toDisplayString(_ctx.$t('panel.reportSettings.deadlines.juryVoting')) + " ", 1),
                            _createElementVNode("i", {
                              class: "fas fa-question-circle text-muted ms-1",
                              "data-bs-toggle": "tooltip",
                              title: _ctx.$t('panel.reportSettings.deadlines.juryVotingHelp')
                            }, null, 8, _hoisted_37)
                          ]),
                          _createElementVNode("div", _hoisted_38, [
                            _withDirectives(_createElementVNode("input", {
                              type: "number",
                              class: "form-control bg-dark text-light",
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.settings.deadlines.juryVotingHours) = $event)),
                              min: "1",
                              max: "720"
                            }, null, 512), [
                              [
                                _vModelText,
                                _ctx.settings.deadlines.juryVotingHours,
                                void 0,
                                { number: true }
                              ]
                            ]),
                            _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.$t('panel.reportSettings.common.hours')), 1)
                          ]),
                          _createElementVNode("small", _hoisted_40, _toDisplayString(_ctx.$t('panel.reportSettings.common.defaultHours', { n: 72 })), 1)
                        ])
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.overwatchDeadlineFields, (field) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "col-md-4",
                          key: field.key
                        }, [
                          _createElementVNode("div", _hoisted_41, [
                            _createElementVNode("label", _hoisted_42, [
                              _createTextVNode(_toDisplayString(_ctx.$t(field.label)) + " ", 1),
                              _createElementVNode("i", {
                                class: "fas fa-question-circle text-muted ms-1",
                                title: _ctx.$t(field.help)
                              }, null, 8, _hoisted_43)
                            ]),
                            _createElementVNode("div", _hoisted_44, [
                              _withDirectives(_createElementVNode("input", {
                                type: "number",
                                class: "form-control bg-dark text-light",
                                "onUpdate:modelValue": ($event: any) => ((_ctx.settings.deadlines[field.key]) = $event),
                                min: "1",
                                max: "720"
                              }, null, 8, _hoisted_45), [
                                [
                                  _vModelText,
                                  _ctx.settings.deadlines[field.key],
                                  void 0,
                                  { number: true }
                                ]
                              ]),
                              _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.$t('panel.reportSettings.common.hours')), 1)
                            ]),
                            _createElementVNode("small", _hoisted_47, _toDisplayString(_ctx.$t('report_settings_admin.default_hours', { hours: field.default })), 1)
                          ])
                        ]))
                      }), 128)),
                      _createElementVNode("div", _hoisted_48, [
                        _createElementVNode("small", _hoisted_49, _toDisplayString(_ctx.$t('report_settings_admin.staff_review_no_timer')), 1)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.activeTab === 'scores')
                ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                    _createElementVNode("div", _hoisted_51, [
                      _createElementVNode("div", null, [
                        _createElementVNode("h5", null, _toDisplayString(_ctx.$t('panel.reportSettings.scores.title')), 1),
                        _createElementVNode("p", _hoisted_52, _toDisplayString(_ctx.$t('panel.reportSettings.scores.subtitle')), 1)
                      ]),
                      _createElementVNode("div", _hoisted_53, [
                        _createElementVNode("button", {
                          class: "btn btn-outline-secondary btn-sm",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.resetDefaults('scores'))),
                          disabled: _ctx.saving
                        }, [
                          _cache[54] || (_cache[54] = _createElementVNode("i", { class: "fas fa-undo me-1" }, null, -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('panel.reportSettings.common.resetDefaults')), 1)
                        ], 8, _hoisted_54),
                        _createElementVNode("button", {
                          class: "btn btn-primary btn-sm",
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.saveSettings('scores'))),
                          disabled: _ctx.saving
                        }, [
                          (_ctx.saving && _ctx.savingSection === 'scores')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_56))
                            : (_openBlock(), _createElementBlock("i", _hoisted_57)),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('panel.reportSettings.common.save')), 1)
                        ], 8, _hoisted_55)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_58, [
                      _createElementVNode("div", _hoisted_59, [
                        _createElementVNode("h6", _hoisted_60, _toDisplayString(_ctx.$t('panel.reportSettings.scores.outcomesTitle')), 1)
                      ]),
                      _createElementVNode("div", _hoisted_61, [
                        _createElementVNode("div", _hoisted_62, [
                          _createElementVNode("label", _hoisted_63, _toDisplayString(_ctx.$t('panel.reportSettings.scores.validReporter')), 1),
                          _createElementVNode("div", _hoisted_64, [
                            _withDirectives(_createElementVNode("input", {
                              type: "number",
                              class: "form-control bg-dark text-light",
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.settings.scores.reportValidReporter) = $event))
                            }, null, 512), [
                              [
                                _vModelText,
                                _ctx.settings.scores.reportValidReporter,
                                void 0,
                                { number: true }
                              ]
                            ]),
                            _createElementVNode("span", _hoisted_65, _toDisplayString(_ctx.$t('panel.reportSettings.common.pts')), 1)
                          ]),
                          _createElementVNode("small", _hoisted_66, _toDisplayString(_ctx.$t('panel.reportSettings.scores.validReporterHelp')), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_67, [
                        _createElementVNode("div", _hoisted_68, [
                          _createElementVNode("label", _hoisted_69, _toDisplayString(_ctx.$t('panel.reportSettings.scores.validReported')), 1),
                          _createElementVNode("div", _hoisted_70, [
                            _withDirectives(_createElementVNode("input", {
                              type: "number",
                              class: "form-control bg-dark text-light",
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.settings.scores.reportValidReported) = $event))
                            }, null, 512), [
                              [
                                _vModelText,
                                _ctx.settings.scores.reportValidReported,
                                void 0,
                                { number: true }
                              ]
                            ]),
                            _createElementVNode("span", _hoisted_71, _toDisplayString(_ctx.$t('panel.reportSettings.common.pts')), 1)
                          ]),
                          _createElementVNode("small", _hoisted_72, _toDisplayString(_ctx.$t('panel.reportSettings.scores.validReportedHelp')), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_73, [
                        _createElementVNode("div", _hoisted_74, [
                          _createElementVNode("label", _hoisted_75, _toDisplayString(_ctx.$t('panel.reportSettings.scores.invalidReporter')), 1),
                          _createElementVNode("div", _hoisted_76, [
                            _withDirectives(_createElementVNode("input", {
                              type: "number",
                              class: "form-control bg-dark text-light",
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.settings.scores.reportInvalidReporter) = $event))
                            }, null, 512), [
                              [
                                _vModelText,
                                _ctx.settings.scores.reportInvalidReporter,
                                void 0,
                                { number: true }
                              ]
                            ]),
                            _createElementVNode("span", _hoisted_77, _toDisplayString(_ctx.$t('panel.reportSettings.common.pts')), 1)
                          ]),
                          _createElementVNode("small", _hoisted_78, _toDisplayString(_ctx.$t('panel.reportSettings.scores.invalidReporterHelp')), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_79, [
                        _createElementVNode("div", _hoisted_80, [
                          _createElementVNode("label", _hoisted_81, _toDisplayString(_ctx.$t('panel.reportSettings.scores.invalidReported')), 1),
                          _createElementVNode("div", _hoisted_82, [
                            _withDirectives(_createElementVNode("input", {
                              type: "number",
                              class: "form-control bg-dark text-light",
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.settings.scores.reportInvalidReported) = $event))
                            }, null, 512), [
                              [
                                _vModelText,
                                _ctx.settings.scores.reportInvalidReported,
                                void 0,
                                { number: true }
                              ]
                            ]),
                            _createElementVNode("span", _hoisted_83, _toDisplayString(_ctx.$t('panel.reportSettings.common.pts')), 1)
                          ]),
                          _createElementVNode("small", _hoisted_84, _toDisplayString(_ctx.$t('panel.reportSettings.scores.invalidReportedHelp')), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_85, [
                        _createElementVNode("h6", _hoisted_86, _toDisplayString(_ctx.$t('panel.reportSettings.scores.acceptanceTitle')), 1)
                      ]),
                      _createElementVNode("div", _hoisted_87, [
                        _createElementVNode("div", _hoisted_88, [
                          _createElementVNode("label", _hoisted_89, _toDisplayString(_ctx.$t('panel.reportSettings.scores.acceptReported')), 1),
                          _createElementVNode("div", _hoisted_90, [
                            _withDirectives(_createElementVNode("input", {
                              type: "number",
                              class: "form-control bg-dark text-light",
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.settings.scores.acceptReported) = $event))
                            }, null, 512), [
                              [
                                _vModelText,
                                _ctx.settings.scores.acceptReported,
                                void 0,
                                { number: true }
                              ]
                            ]),
                            _createElementVNode("span", _hoisted_91, _toDisplayString(_ctx.$t('panel.reportSettings.common.pts')), 1)
                          ]),
                          _createElementVNode("small", _hoisted_92, _toDisplayString(_ctx.$t('panel.reportSettings.scores.acceptReportedHelp')), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_93, [
                        _createElementVNode("div", _hoisted_94, [
                          _createElementVNode("label", _hoisted_95, _toDisplayString(_ctx.$t('panel.reportSettings.scores.juryParticipation')), 1),
                          _createElementVNode("div", _hoisted_96, [
                            _withDirectives(_createElementVNode("input", {
                              type: "number",
                              class: "form-control bg-dark text-light",
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.settings.scores.juryParticipation) = $event))
                            }, null, 512), [
                              [
                                _vModelText,
                                _ctx.settings.scores.juryParticipation,
                                void 0,
                                { number: true }
                              ]
                            ]),
                            _createElementVNode("span", _hoisted_97, _toDisplayString(_ctx.$t('panel.reportSettings.common.pts')), 1)
                          ]),
                          _createElementVNode("small", _hoisted_98, _toDisplayString(_ctx.$t('panel.reportSettings.scores.juryParticipationHelp')), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_99, [
                        _createElementVNode("div", _hoisted_100, [
                          _createElementVNode("label", _hoisted_101, _toDisplayString(_ctx.$t('panel.reportSettings.scores.juryCorrectVote')), 1),
                          _createElementVNode("div", _hoisted_102, [
                            _withDirectives(_createElementVNode("input", {
                              type: "number",
                              class: "form-control bg-dark text-light",
                              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.settings.scores.juryCorrectVote) = $event))
                            }, null, 512), [
                              [
                                _vModelText,
                                _ctx.settings.scores.juryCorrectVote,
                                void 0,
                                { number: true }
                              ]
                            ]),
                            _createElementVNode("span", _hoisted_103, _toDisplayString(_ctx.$t('panel.reportSettings.common.pts')), 1)
                          ]),
                          _createElementVNode("small", _hoisted_104, _toDisplayString(_ctx.$t('panel.reportSettings.scores.juryCorrectVoteHelp')), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_105, [
                        _createElementVNode("div", _hoisted_106, [
                          _createElementVNode("label", _hoisted_107, _toDisplayString(_ctx.$t('panel.reportSettings.scores.juryIncorrectVote')), 1),
                          _createElementVNode("div", _hoisted_108, [
                            _withDirectives(_createElementVNode("input", {
                              type: "number",
                              class: "form-control bg-dark text-light",
                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.settings.scores.juryIncorrectVote) = $event))
                            }, null, 512), [
                              [
                                _vModelText,
                                _ctx.settings.scores.juryIncorrectVote,
                                void 0,
                                { number: true }
                              ]
                            ]),
                            _createElementVNode("span", _hoisted_109, _toDisplayString(_ctx.$t('panel.reportSettings.common.pts')), 1)
                          ]),
                          _createElementVNode("small", _hoisted_110, _toDisplayString(_ctx.$t('panel.reportSettings.scores.juryIncorrectVoteHelp')), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_111, [
                        _createElementVNode("h6", _hoisted_112, _toDisplayString(_ctx.$t('panel.reportSettings.scores.severityTitle')), 1)
                      ]),
                      _createElementVNode("div", _hoisted_113, [
                        _createElementVNode("div", _hoisted_114, [
                          _createElementVNode("label", _hoisted_115, _toDisplayString(_ctx.$t('panel.reportSettings.scores.perSeverityPoint')), 1),
                          _createElementVNode("div", _hoisted_116, [
                            _withDirectives(_createElementVNode("input", {
                              type: "number",
                              class: "form-control bg-dark text-light",
                              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.settings.scores.perSeverityPoint) = $event))
                            }, null, 512), [
                              [
                                _vModelText,
                                _ctx.settings.scores.perSeverityPoint,
                                void 0,
                                { number: true }
                              ]
                            ]),
                            _createElementVNode("span", _hoisted_117, _toDisplayString(_ctx.$t('panel.reportSettings.common.pts')), 1)
                          ]),
                          _createElementVNode("small", _hoisted_118, _toDisplayString(_ctx.$t('panel.reportSettings.scores.perSeverityPointHelp')), 1)
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.activeTab === 'jury')
                ? (_openBlock(), _createElementBlock("div", _hoisted_119, [
                    _createElementVNode("div", _hoisted_120, [
                      _createElementVNode("div", null, [
                        _createElementVNode("h5", null, _toDisplayString(_ctx.$t('panel.reportSettings.jury.title')), 1),
                        _createElementVNode("p", _hoisted_121, _toDisplayString(_ctx.$t('panel.reportSettings.jury.subtitle')), 1)
                      ]),
                      _createElementVNode("div", _hoisted_122, [
                        _createElementVNode("button", {
                          class: "btn btn-outline-secondary btn-sm",
                          onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.resetDefaults('jury'))),
                          disabled: _ctx.saving
                        }, [
                          _cache[55] || (_cache[55] = _createElementVNode("i", { class: "fas fa-undo me-1" }, null, -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('panel.reportSettings.common.resetDefaults')), 1)
                        ], 8, _hoisted_123),
                        _createElementVNode("button", {
                          class: "btn btn-primary btn-sm",
                          onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.saveSettings('jury'))),
                          disabled: _ctx.saving
                        }, [
                          (_ctx.saving && _ctx.savingSection === 'jury')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_125))
                            : (_openBlock(), _createElementBlock("i", _hoisted_126)),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('panel.reportSettings.common.save')), 1)
                        ], 8, _hoisted_124)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_127, [
                      _createElementVNode("div", _hoisted_128, [
                        _createElementVNode("h6", _hoisted_129, _toDisplayString(_ctx.$t('panel.reportSettings.jury.compositionTitle')), 1)
                      ]),
                      _createElementVNode("div", _hoisted_130, [
                        _createElementVNode("div", _hoisted_131, [
                          _createElementVNode("label", _hoisted_132, _toDisplayString(_ctx.$t('panel.reportSettings.jury.size')), 1),
                          _withDirectives(_createElementVNode("input", {
                            type: "number",
                            class: "form-control bg-dark text-light",
                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.settings.jury.jurySize) = $event)),
                            min: "3",
                            max: "15"
                          }, null, 512), [
                            [
                              _vModelText,
                              _ctx.settings.jury.jurySize,
                              void 0,
                              { number: true }
                            ]
                          ]),
                          _createElementVNode("small", _hoisted_133, _toDisplayString(_ctx.$t('panel.reportSettings.jury.sizeHelp')), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_134, [
                        _createElementVNode("div", _hoisted_135, [
                          _createElementVNode("label", _hoisted_136, _toDisplayString(_ctx.$t('panel.reportSettings.jury.maxCount')), 1),
                          _withDirectives(_createElementVNode("input", {
                            type: "number",
                            class: "form-control bg-dark text-light",
                            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.settings.jury.maxJuryCount) = $event)),
                            min: "3",
                            max: "20"
                          }, null, 512), [
                            [
                              _vModelText,
                              _ctx.settings.jury.maxJuryCount,
                              void 0,
                              { number: true }
                            ]
                          ]),
                          _createElementVNode("small", _hoisted_137, _toDisplayString(_ctx.$t('panel.reportSettings.jury.maxCountHelp')), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_138, [
                        _createElementVNode("div", _hoisted_139, [
                          _createElementVNode("label", _hoisted_140, _toDisplayString(_ctx.$t('panel.reportSettings.jury.minVotes')), 1),
                          _withDirectives(_createElementVNode("input", {
                            type: "number",
                            class: "form-control bg-dark text-light",
                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.settings.jury.minVotesRequired) = $event)),
                            min: "1",
                            max: _ctx.settings.jury.jurySize
                          }, null, 8, _hoisted_141), [
                            [
                              _vModelText,
                              _ctx.settings.jury.minVotesRequired,
                              void 0,
                              { number: true }
                            ]
                          ]),
                          _createElementVNode("small", _hoisted_142, _toDisplayString(_ctx.$t('panel.reportSettings.jury.minVotesHelp')), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_143, [
                        _createElementVNode("div", _hoisted_144, [
                          _createElementVNode("label", _hoisted_145, _toDisplayString(_ctx.$t('panel.reportSettings.jury.majorityType')), 1),
                          _withDirectives(_createElementVNode("select", {
                            class: "form-select bg-dark text-light",
                            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.settings.jury.majorityType) = $event))
                          }, [
                            _createElementVNode("option", _hoisted_146, _toDisplayString(_ctx.$t('panel.reportSettings.jury.majoritySimple')), 1),
                            _createElementVNode("option", _hoisted_147, _toDisplayString(_ctx.$t('panel.reportSettings.jury.majoritySuper')), 1)
                          ], 512), [
                            [_vModelSelect, _ctx.settings.jury.majorityType]
                          ]),
                          _createElementVNode("small", _hoisted_148, _toDisplayString(_ctx.$t('panel.reportSettings.jury.majorityTypeHelp')), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_149, [
                        _createElementVNode("h6", _hoisted_150, _toDisplayString(_ctx.$t('panel.reportSettings.jury.eligibilityTitle')), 1)
                      ]),
                      _createElementVNode("div", _hoisted_151, [
                        _createElementVNode("div", _hoisted_152, [
                          _createElementVNode("label", _hoisted_153, _toDisplayString(_ctx.$t('panel.reportSettings.jury.minScore')), 1),
                          _withDirectives(_createElementVNode("input", {
                            type: "number",
                            class: "form-control bg-dark text-light",
                            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.settings.jury.minScore) = $event)),
                            max: _ctx.settings.jury.trainingStartScore
                          }, null, 8, _hoisted_154), [
                            [
                              _vModelText,
                              _ctx.settings.jury.minScore,
                              void 0,
                              { number: true }
                            ]
                          ]),
                          _createElementVNode("small", _hoisted_155, _toDisplayString(_ctx.$t('overwatch.admin_min_score_rule', { start: _ctx.settings.jury.trainingStartScore })), 1),
                          (_ctx.settings.jury.minScore > _ctx.settings.jury.trainingStartScore)
                            ? (_openBlock(), _createElementBlock("small", _hoisted_156, _toDisplayString(_ctx.$t('overwatch.admin_min_score_clamped', { start: _ctx.settings.jury.trainingStartScore })), 1))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_157, [
                        _createElementVNode("div", _hoisted_158, [
                          _createElementVNode("label", _hoisted_159, _toDisplayString(_ctx.$t('overwatch.admin_training_start_score')), 1),
                          _withDirectives(_createElementVNode("input", {
                            type: "number",
                            class: "form-control bg-dark text-light",
                            "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.settings.jury.trainingStartScore) = $event)),
                            min: "0"
                          }, null, 512), [
                            [
                              _vModelText,
                              _ctx.settings.jury.trainingStartScore,
                              void 0,
                              { number: true }
                            ]
                          ]),
                          _createElementVNode("small", _hoisted_160, _toDisplayString(_ctx.$t('overwatch.admin_training_start_score_help')), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_161, [
                        _createElementVNode("div", _hoisted_162, [
                          _createElementVNode("label", _hoisted_163, _toDisplayString(_ctx.$t('panel.reportSettings.jury.minAccountAge')), 1),
                          _createElementVNode("div", _hoisted_164, [
                            _withDirectives(_createElementVNode("input", {
                              type: "number",
                              class: "form-control bg-dark text-light",
                              "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.settings.jury.minAccountAgeDays) = $event)),
                              min: "0"
                            }, null, 512), [
                              [
                                _vModelText,
                                _ctx.settings.jury.minAccountAgeDays,
                                void 0,
                                { number: true }
                              ]
                            ]),
                            _createElementVNode("span", _hoisted_165, _toDisplayString(_ctx.$t('panel.reportSettings.common.days')), 1)
                          ]),
                          _createElementVNode("small", _hoisted_166, _toDisplayString(_ctx.$t('panel.reportSettings.jury.minAccountAgeHelp')), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_167, [
                        _createElementVNode("div", _hoisted_168, [
                          _createElementVNode("label", _hoisted_169, _toDisplayString(_ctx.$t('panel.reportSettings.jury.maxActiveDuties')), 1),
                          _withDirectives(_createElementVNode("input", {
                            type: "number",
                            class: "form-control bg-dark text-light",
                            "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.settings.jury.maxActiveJuryDuties) = $event)),
                            min: "1",
                            max: "10"
                          }, null, 512), [
                            [
                              _vModelText,
                              _ctx.settings.jury.maxActiveJuryDuties,
                              void 0,
                              { number: true }
                            ]
                          ]),
                          _createElementVNode("small", _hoisted_170, _toDisplayString(_ctx.$t('panel.reportSettings.jury.maxActiveDutiesHelp')), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_171, [
                        _createElementVNode("div", _hoisted_172, [
                          _createElementVNode("label", _hoisted_173, _toDisplayString(_ctx.$t('panel.reportSettings.jury.excludeStaff')), 1),
                          _createElementVNode("div", _hoisted_174, [
                            _withDirectives(_createElementVNode("input", {
                              class: "form-check-input",
                              type: "checkbox",
                              id: "excludeStaff",
                              "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.settings.jury.excludeStaff) = $event))
                            }, null, 512), [
                              [_vModelCheckbox, _ctx.settings.jury.excludeStaff]
                            ]),
                            _createElementVNode("label", _hoisted_175, _toDisplayString(_ctx.settings.jury.excludeStaff ? _ctx.$t('panel.reportSettings.common.yes') : _ctx.$t('panel.reportSettings.common.no')), 1)
                          ]),
                          _createElementVNode("small", _hoisted_176, _toDisplayString(_ctx.$t('panel.reportSettings.jury.excludeStaffHelp')), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_177, [
                        _createElementVNode("div", _hoisted_178, [
                          _createElementVNode("label", _hoisted_179, _toDisplayString(_ctx.$t('panel.reportSettings.jury.excludeSameFaction')), 1),
                          _createElementVNode("div", _hoisted_180, [
                            _withDirectives(_createElementVNode("input", {
                              class: "form-check-input",
                              type: "checkbox",
                              id: "excludeSameFaction",
                              "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.settings.jury.excludeSameFaction) = $event))
                            }, null, 512), [
                              [_vModelCheckbox, _ctx.settings.jury.excludeSameFaction]
                            ]),
                            _createElementVNode("label", _hoisted_181, _toDisplayString(_ctx.settings.jury.excludeSameFaction ? _ctx.$t('panel.reportSettings.common.yes') : _ctx.$t('panel.reportSettings.common.no')), 1)
                          ]),
                          _createElementVNode("small", _hoisted_182, _toDisplayString(_ctx.$t('panel.reportSettings.jury.excludeSameFactionHelp')), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_183, [
                        _createElementVNode("div", _hoisted_184, [
                          _createElementVNode("label", _hoisted_185, _toDisplayString(_ctx.$t('panel.reportSettings.jury.excludeKnownUsers')), 1),
                          _createElementVNode("div", _hoisted_186, [
                            _withDirectives(_createElementVNode("input", {
                              class: "form-check-input",
                              type: "checkbox",
                              id: "excludeKnownUsers",
                              "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.settings.jury.excludeKnownUsers) = $event))
                            }, null, 512), [
                              [_vModelCheckbox, _ctx.settings.jury.excludeKnownUsers]
                            ]),
                            _createElementVNode("label", _hoisted_187, _toDisplayString(_ctx.settings.jury.excludeKnownUsers ? _ctx.$t('panel.reportSettings.common.yes') : _ctx.$t('panel.reportSettings.common.no')), 1)
                          ]),
                          _createElementVNode("small", _hoisted_188, _toDisplayString(_ctx.$t('panel.reportSettings.jury.excludeKnownUsersHelp')), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_189, [
                        _createElementVNode("div", _hoisted_190, [
                          _createElementVNode("label", _hoisted_191, _toDisplayString(_ctx.$t('panel.reportSettings.jury.rotation')), 1),
                          _createElementVNode("div", _hoisted_192, [
                            _withDirectives(_createElementVNode("input", {
                              type: "number",
                              class: "form-control bg-dark text-light",
                              "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.settings.jury.rotationDays) = $event)),
                              min: "0",
                              max: "90"
                            }, null, 512), [
                              [
                                _vModelText,
                                _ctx.settings.jury.rotationDays,
                                void 0,
                                { number: true }
                              ]
                            ]),
                            _createElementVNode("span", _hoisted_193, _toDisplayString(_ctx.$t('panel.reportSettings.common.days')), 1)
                          ]),
                          _createElementVNode("small", _hoisted_194, _toDisplayString(_ctx.$t('panel.reportSettings.jury.rotationHelp')), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_195, [
                        _createElementVNode("div", _hoisted_196, [
                          _createElementVNode("label", _hoisted_197, _toDisplayString(_ctx.$t('panel.reportSettings.jury.honorableMinScore')), 1),
                          _withDirectives(_createElementVNode("input", {
                            type: "number",
                            class: "form-control bg-dark text-light",
                            "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.settings.jury.honorableMinScore) = $event)),
                            min: "0"
                          }, null, 512), [
                            [
                              _vModelText,
                              _ctx.settings.jury.honorableMinScore,
                              void 0,
                              { number: true }
                            ]
                          ]),
                          _createElementVNode("small", _hoisted_198, _toDisplayString(_ctx.$t('panel.reportSettings.jury.honorableMinScoreHelp')), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_199, [
                        _createElementVNode("div", _hoisted_200, [
                          _createElementVNode("label", _hoisted_201, _toDisplayString(_ctx.$t('panel.reportSettings.jury.honorableMinVotes')), 1),
                          _withDirectives(_createElementVNode("input", {
                            type: "number",
                            class: "form-control bg-dark text-light",
                            "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.settings.jury.honorableMinCorrectVotes) = $event)),
                            min: "0"
                          }, null, 512), [
                            [
                              _vModelText,
                              _ctx.settings.jury.honorableMinCorrectVotes,
                              void 0,
                              { number: true }
                            ]
                          ]),
                          _createElementVNode("small", _hoisted_202, _toDisplayString(_ctx.$t('panel.reportSettings.jury.honorableMinVotesHelp')), 1)
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.activeTab === 'staffReview')
                ? (_openBlock(), _createElementBlock("div", _hoisted_203, [
                    _createElementVNode("div", _hoisted_204, [
                      _createElementVNode("div", null, [
                        _createElementVNode("h5", null, _toDisplayString(_ctx.$t('panel.reportSettings.staffReview.title')), 1),
                        _createElementVNode("p", _hoisted_205, _toDisplayString(_ctx.$t('report_settings_admin.staff_vote_subtitle')), 1)
                      ]),
                      _createElementVNode("div", _hoisted_206, [
                        _createElementVNode("button", {
                          class: "btn btn-outline-secondary btn-sm",
                          onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.resetDefaults('staffReview'))),
                          disabled: _ctx.saving
                        }, [
                          _cache[56] || (_cache[56] = _createElementVNode("i", { class: "fas fa-undo me-1" }, null, -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('panel.reportSettings.common.resetDefaults')), 1)
                        ], 8, _hoisted_207),
                        _createElementVNode("button", {
                          class: "btn btn-primary btn-sm",
                          onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.saveSettings('staffReview'))),
                          disabled: _ctx.saving
                        }, [
                          (_ctx.saving && _ctx.savingSection === 'staffReview')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_209))
                            : (_openBlock(), _createElementBlock("i", _hoisted_210)),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('panel.reportSettings.common.save')), 1)
                        ], 8, _hoisted_208)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_211, [
                      _createElementVNode("div", _hoisted_212, [
                        _createElementVNode("div", _hoisted_213, [
                          _createElementVNode("label", _hoisted_214, _toDisplayString(_ctx.$t('panel.reportSettings.staffReview.voteMode')), 1),
                          _withDirectives(_createElementVNode("select", {
                            class: "form-select bg-dark text-light",
                            "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.settings.staffReview.mode) = $event))
                          }, [
                            _createElementVNode("option", _hoisted_215, _toDisplayString(_ctx.$t('panel.reportSettings.staffReview.modeAny')), 1),
                            _createElementVNode("option", _hoisted_216, _toDisplayString(_ctx.$t('panel.reportSettings.staffReview.modeAutoAssign')), 1)
                          ], 512), [
                            [_vModelSelect, _ctx.settings.staffReview.mode]
                          ]),
                          _createElementVNode("small", _hoisted_217, _toDisplayString(_ctx.$t('panel.reportSettings.staffReview.voteModeHelp')), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_218, [
                        _createElementVNode("div", _hoisted_219, [
                          _createElementVNode("label", _hoisted_220, _toDisplayString(_ctx.$t('panel.reportSettings.staffReview.autoAssignCount')), 1),
                          _withDirectives(_createElementVNode("input", {
                            type: "number",
                            class: "form-control bg-dark text-light",
                            "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.settings.staffReview.autoAssignCount) = $event)),
                            min: "1",
                            max: "50"
                          }, null, 512), [
                            [
                              _vModelText,
                              _ctx.settings.staffReview.autoAssignCount,
                              void 0,
                              { number: true }
                            ]
                          ]),
                          _createElementVNode("small", _hoisted_221, _toDisplayString(_ctx.$t('panel.reportSettings.staffReview.autoAssignCountHelp')), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_222, [
                        _createElementVNode("div", _hoisted_223, [
                          _createElementVNode("label", _hoisted_224, _toDisplayString(_ctx.$t('report_settings_admin.threshold_mode')), 1),
                          _withDirectives(_createElementVNode("select", {
                            class: "form-select bg-dark text-light",
                            "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.settings.staffReview.thresholdMode) = $event))
                          }, [
                            _createElementVNode("option", _hoisted_225, _toDisplayString(_ctx.$t('report_settings_admin.threshold_mode_majority')), 1),
                            _createElementVNode("option", _hoisted_226, _toDisplayString(_ctx.$t('report_settings_admin.threshold_mode_percent')), 1)
                          ], 512), [
                            [_vModelSelect, _ctx.settings.staffReview.thresholdMode]
                          ]),
                          _createElementVNode("small", _hoisted_227, _toDisplayString(_ctx.$t('report_settings_admin.threshold_mode_help')), 1)
                        ])
                      ]),
                      (_ctx.settings.staffReview.thresholdMode !== 'percent_of_pool')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_228, [
                            _createElementVNode("div", _hoisted_229, [
                              _createElementVNode("label", _hoisted_230, _toDisplayString(_ctx.$t('report_settings_admin.min_votes')), 1),
                              _withDirectives(_createElementVNode("input", {
                                type: "number",
                                class: "form-control bg-dark text-light",
                                "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.settings.staffReview.minVotes) = $event)),
                                min: "1",
                                max: "50"
                              }, null, 512), [
                                [
                                  _vModelText,
                                  _ctx.settings.staffReview.minVotes,
                                  void 0,
                                  { number: true }
                                ]
                              ]),
                              _createElementVNode("small", _hoisted_231, _toDisplayString(_ctx.$t('report_settings_admin.min_votes_help')), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.settings.staffReview.thresholdMode === 'percent_of_pool')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_232, [
                            _createElementVNode("div", _hoisted_233, [
                              _createElementVNode("label", _hoisted_234, _toDisplayString(_ctx.$t('panel.reportSettings.staffReview.threshold')), 1),
                              _withDirectives(_createElementVNode("input", {
                                type: "number",
                                class: "form-control bg-dark text-light",
                                "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.settings.staffReview.thresholdPercent) = $event)),
                                min: "1",
                                max: "100"
                              }, null, 512), [
                                [
                                  _vModelText,
                                  _ctx.settings.staffReview.thresholdPercent,
                                  void 0,
                                  { number: true }
                                ]
                              ]),
                              _createElementVNode("small", _hoisted_235, _toDisplayString(_ctx.$t('panel.reportSettings.staffReview.thresholdHelp')), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.settings.staffReview.thresholdMode === 'percent_of_pool')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_236, [
                            _createElementVNode("div", _hoisted_237, [
                              _createElementVNode("label", _hoisted_238, _toDisplayString(_ctx.$t('panel.reportSettings.staffReview.poolSize')), 1),
                              _withDirectives(_createElementVNode("input", {
                                type: "number",
                                class: "form-control bg-dark text-light",
                                "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.settings.staffReview.poolSizeForAny) = $event)),
                                min: "1",
                                max: "50"
                              }, null, 512), [
                                [
                                  _vModelText,
                                  _ctx.settings.staffReview.poolSizeForAny,
                                  void 0,
                                  { number: true }
                                ]
                              ]),
                              _createElementVNode("small", _hoisted_239, _toDisplayString(_ctx.$t('panel.reportSettings.staffReview.poolSizeHelp')), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.activeTab === 'reduction')
                ? (_openBlock(), _createElementBlock("div", _hoisted_240, [
                    _createElementVNode("div", _hoisted_241, [
                      _createElementVNode("div", null, [
                        _createElementVNode("h5", null, _toDisplayString(_ctx.$t('panel.reportSettings.reduction.title')), 1),
                        _createElementVNode("p", _hoisted_242, _toDisplayString(_ctx.$t('panel.reportSettings.reduction.subtitle')), 1)
                      ]),
                      _createElementVNode("div", _hoisted_243, [
                        _createElementVNode("button", {
                          class: "btn btn-outline-secondary btn-sm",
                          onClick: _cache[40] || (_cache[40] = ($event: any) => (_ctx.resetDefaults('reduction'))),
                          disabled: _ctx.saving
                        }, [
                          _cache[57] || (_cache[57] = _createElementVNode("i", { class: "fas fa-undo me-1" }, null, -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('panel.reportSettings.common.resetDefaults')), 1)
                        ], 8, _hoisted_244),
                        _createElementVNode("button", {
                          class: "btn btn-primary btn-sm",
                          onClick: _cache[41] || (_cache[41] = ($event: any) => (_ctx.saveSettings('reduction'))),
                          disabled: _ctx.saving
                        }, [
                          (_ctx.saving && _ctx.savingSection === 'reduction')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_246))
                            : (_openBlock(), _createElementBlock("i", _hoisted_247)),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('panel.reportSettings.common.save')), 1)
                        ], 8, _hoisted_245)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_248, [
                      _createElementVNode("div", _hoisted_249, [
                        _createElementVNode("div", _hoisted_250, [
                          _createElementVNode("label", _hoisted_251, _toDisplayString(_ctx.$t('panel.reportSettings.reduction.percent')), 1),
                          _createElementVNode("div", _hoisted_252, [
                            _withDirectives(_createElementVNode("input", {
                              type: "range",
                              class: "form-range flex-grow-1",
                              "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.settings.reduction.reductionPercent) = $event)),
                              min: "0",
                              max: "100",
                              step: "5"
                            }, null, 512), [
                              [
                                _vModelText,
                                _ctx.settings.reduction.reductionPercent,
                                void 0,
                                { number: true }
                              ]
                            ]),
                            _createElementVNode("span", _hoisted_253, _toDisplayString(_ctx.settings.reduction.reductionPercent) + "% ", 1)
                          ]),
                          _createElementVNode("small", _hoisted_254, _toDisplayString(_ctx.$t('panel.reportSettings.reduction.percentHelp')), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_255, [
                        _createElementVNode("div", _hoisted_256, [
                          _createElementVNode("label", _hoisted_257, _toDisplayString(_ctx.$t('panel.reportSettings.reduction.appliesTo')), 1),
                          _withDirectives(_createElementVNode("select", {
                            class: "form-select bg-dark text-light",
                            "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.settings.reduction.appliesTo) = $event))
                          }, [
                            _createElementVNode("option", _hoisted_258, _toDisplayString(_ctx.$t('panel.reportSettings.reduction.severity')), 1),
                            _createElementVNode("option", _hoisted_259, _toDisplayString(_ctx.$t('panel.reportSettings.reduction.quantity')), 1),
                            _createElementVNode("option", _hoisted_260, _toDisplayString(_ctx.$t('panel.reportSettings.reduction.both')), 1)
                          ], 512), [
                            [_vModelSelect, _ctx.settings.reduction.appliesTo]
                          ]),
                          _createElementVNode("small", _hoisted_261, _toDisplayString(_ctx.$t('panel.reportSettings.reduction.appliesToHelp')), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_262, [
                        _createElementVNode("div", _hoisted_263, [
                          _createElementVNode("label", _hoisted_264, _toDisplayString(_ctx.$t('panel.reportSettings.reduction.minSeverity')), 1),
                          _withDirectives(_createElementVNode("input", {
                            type: "number",
                            class: "form-control bg-dark text-light",
                            "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.settings.reduction.minSeverityAfterReduction) = $event)),
                            min: "1",
                            max: "10"
                          }, null, 512), [
                            [
                              _vModelText,
                              _ctx.settings.reduction.minSeverityAfterReduction,
                              void 0,
                              { number: true }
                            ]
                          ]),
                          _createElementVNode("small", _hoisted_265, _toDisplayString(_ctx.$t('panel.reportSettings.reduction.minSeverityHelp')), 1)
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.activeTab === 'general')
                ? (_openBlock(), _createElementBlock("div", _hoisted_266, [
                    _createElementVNode("div", _hoisted_267, [
                      _createElementVNode("div", null, [
                        _createElementVNode("h5", null, _toDisplayString(_ctx.$t('panel.reportSettings.general.title')), 1),
                        _createElementVNode("p", _hoisted_268, _toDisplayString(_ctx.$t('panel.reportSettings.general.subtitle')), 1)
                      ]),
                      _createElementVNode("div", _hoisted_269, [
                        _createElementVNode("button", {
                          class: "btn btn-outline-secondary btn-sm",
                          onClick: _cache[45] || (_cache[45] = ($event: any) => (_ctx.resetDefaults('general'))),
                          disabled: _ctx.saving
                        }, [
                          _cache[58] || (_cache[58] = _createElementVNode("i", { class: "fas fa-undo me-1" }, null, -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('panel.reportSettings.common.resetDefaults')), 1)
                        ], 8, _hoisted_270),
                        _createElementVNode("button", {
                          class: "btn btn-primary btn-sm",
                          onClick: _cache[46] || (_cache[46] = ($event: any) => (_ctx.saveSettings('general'))),
                          disabled: _ctx.saving
                        }, [
                          (_ctx.saving && _ctx.savingSection === 'general')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_272))
                            : (_openBlock(), _createElementBlock("i", _hoisted_273)),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('panel.reportSettings.common.save')), 1)
                        ], 8, _hoisted_271)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_274, [
                      _createElementVNode("div", _hoisted_275, [
                        _createElementVNode("div", _hoisted_276, [
                          _createElementVNode("label", _hoisted_277, _toDisplayString(_ctx.$t('panel.reportSettings.general.maxBlocks')), 1),
                          _withDirectives(_createElementVNode("input", {
                            type: "number",
                            class: "form-control bg-dark text-light",
                            "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.settings.general.maxPenaltyBlocks) = $event)),
                            min: "1",
                            max: "20"
                          }, null, 512), [
                            [
                              _vModelText,
                              _ctx.settings.general.maxPenaltyBlocks,
                              void 0,
                              { number: true }
                            ]
                          ]),
                          _createElementVNode("small", _hoisted_278, _toDisplayString(_ctx.$t('panel.reportSettings.general.maxBlocksHelp')), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_279, [
                        _createElementVNode("div", _hoisted_280, [
                          _createElementVNode("label", _hoisted_281, _toDisplayString(_ctx.$t('panel.reportSettings.general.maxEvidence')), 1),
                          _withDirectives(_createElementVNode("input", {
                            type: "number",
                            class: "form-control bg-dark text-light",
                            "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.settings.general.maxEvidenceItems) = $event)),
                            min: "1",
                            max: "50"
                          }, null, 512), [
                            [
                              _vModelText,
                              _ctx.settings.general.maxEvidenceItems,
                              void 0,
                              { number: true }
                            ]
                          ]),
                          _createElementVNode("small", _hoisted_282, _toDisplayString(_ctx.$t('panel.reportSettings.general.maxEvidenceHelp')), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_283, [
                        _createElementVNode("div", _hoisted_284, [
                          _createElementVNode("label", _hoisted_285, _toDisplayString(_ctx.$t('panel.reportSettings.general.maxJuryMessages')), 1),
                          _withDirectives(_createElementVNode("input", {
                            type: "number",
                            class: "form-control bg-dark text-light",
                            "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.settings.general.maxJuryPhaseMessages) = $event)),
                            min: "1",
                            max: "50"
                          }, null, 512), [
                            [
                              _vModelText,
                              _ctx.settings.general.maxJuryPhaseMessages,
                              void 0,
                              { number: true }
                            ]
                          ]),
                          _createElementVNode("small", _hoisted_286, _toDisplayString(_ctx.$t('panel.reportSettings.general.maxJuryMessagesHelp')), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_287, [
                        _createElementVNode("div", _hoisted_288, [
                          _createElementVNode("label", _hoisted_289, _toDisplayString(_ctx.$t('panel.reportSettings.general.allowAnonymous')), 1),
                          _createElementVNode("div", _hoisted_290, [
                            _withDirectives(_createElementVNode("input", {
                              class: "form-check-input",
                              type: "checkbox",
                              id: "allowAnonymous",
                              "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.settings.general.allowAnonymousReports) = $event))
                            }, null, 512), [
                              [_vModelCheckbox, _ctx.settings.general.allowAnonymousReports]
                            ]),
                            _createElementVNode("label", _hoisted_291, _toDisplayString(_ctx.settings.general.allowAnonymousReports ? _ctx.$t('panel.reportSettings.common.enabled') : _ctx.$t('panel.reportSettings.common.disabled')), 1)
                          ]),
                          _createElementVNode("small", _hoisted_292, _toDisplayString(_ctx.$t('panel.reportSettings.general.allowAnonymousHelp')), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_293, [
                        _createElementVNode("div", _hoisted_294, [
                          _createElementVNode("label", _hoisted_295, _toDisplayString(_ctx.$t('panel.reportSettings.general.requireEvidence')), 1),
                          _createElementVNode("div", _hoisted_296, [
                            _withDirectives(_createElementVNode("input", {
                              class: "form-check-input",
                              type: "checkbox",
                              id: "requireEvidence",
                              "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.settings.general.requireEvidence) = $event))
                            }, null, 512), [
                              [_vModelCheckbox, _ctx.settings.general.requireEvidence]
                            ]),
                            _createElementVNode("label", _hoisted_297, _toDisplayString(_ctx.settings.general.requireEvidence ? _ctx.$t('panel.reportSettings.common.required') : _ctx.$t('panel.reportSettings.common.optional')), 1)
                          ]),
                          _createElementVNode("small", _hoisted_298, _toDisplayString(_ctx.$t('panel.reportSettings.general.requireEvidenceHelp')), 1)
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])),
    _createElementVNode("div", _hoisted_299, [
      _createElementVNode("div", {
        class: _normalizeClass(["toast", {'show': _ctx.showToast}]),
        role: "alert"
      }, [
        _createElementVNode("div", _hoisted_300, [
          _createElementVNode("i", {
            class: _normalizeClass([_ctx.toastIcon, "me-2"])
          }, null, 2),
          _createElementVNode("strong", _hoisted_301, _toDisplayString(_ctx.toastTitle), 1),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close btn-close-white",
            onClick: _cache[52] || (_cache[52] = ($event: any) => (_ctx.showToast = false))
          })
        ]),
        _createElementVNode("div", _hoisted_302, _toDisplayString(_ctx.toastMessage), 1)
      ], 2)
    ])
  ]))
}